<template>
  <nav class="navbar py-0 navbar-expand-lg navbar-light bg-uvu">
    
    <div class="container-fluid bg-uvu">
      <div class="navbar-brand text-white d-flex align-items-center gap-2 text-uppercase">
          <img src="@/assets/images/UVUMonogramWhite-0007.png"  class="d-none d-sm-block" style="opacity:0.90;" alt="Utah Valley University" height="50" />
          <span class="h6 mb-0">{{sessionStore.app_title}}</span>
      </div>

      <button class="navbar-toggler btn-sm ms-auto my-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center justify-content-lg-start align-items-center mb-md-0 font-14">
            <li><router-link to="/" class="nav-link text-white" v-if="sessionStore.inRole('SectionAuthorization.Admin') || sessionStore.inRole('SectionAuthorization.ActiveStudent') || isAdminAddedManual">My Requests</router-link></li>
            <li><router-link to="/assignments" class="nav-link text-white border-botton" v-if="sessionStore.inRole('SectionAuthorization.Admin') || sessionStore.inRole('SectionAuthorization.Faculty')">Approval Requests</router-link></li>
            <li><router-link to="/departments" class="nav-link text-white" v-if="sessionStore.inRole('SectionAuthorization.Admin') || sessionStore.inRole('SectionAuthorization.DepartmentAdmin') || isAdminAddedManual">Department Requests</router-link></li>
            <li><router-link to="/requests" class="nav-link text-white" v-if="sessionStore.inRole('SectionAuthorization.Admin') || sessionStore.inRole('SectionAuthorization.Registrar')">Request History</router-link></li>
            <li class="nav-item dropdown " v-if="sessionStore.inRole('SectionAuthorization.Admin') || sessionStore.inRole('SectionAuthorization.DepartmentAdmin')">
                <button class="btn btn-transparent text-white dropdown-toggle font-14" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="menu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path fill="currentColor" d="M128 82a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46Zm0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34Zm86-31.16c.06-1.89.06-3.79 0-5.68L229.33 106a6 6 0 0 0 1.11-5.29a105.34 105.34 0 0 0-10.68-25.81a6 6 0 0 0-4.53-3l-24.45-2.71q-1.93-2.07-4-4l-2.72-24.46a6 6 0 0 0-3-4.53a105.65 105.65 0 0 0-25.77-10.66a6 6 0 0 0-5.29 1.14l-19.2 15.37a89.64 89.64 0 0 0-5.68 0L106 26.67a6 6 0 0 0-5.29-1.11A105.34 105.34 0 0 0 74.9 36.24a6 6 0 0 0-3 4.53l-2.67 24.45q-2.07 1.94-4 4L40.76 72a6 6 0 0 0-4.53 3a105.65 105.65 0 0 0-10.66 25.77a6 6 0 0 0 1.11 5.23l15.37 19.2a89.64 89.64 0 0 0 0 5.68l-15.38 19.17a6 6 0 0 0-1.11 5.29a105.34 105.34 0 0 0 10.68 25.76a6 6 0 0 0 4.53 3l24.45 2.71q1.94 2.07 4 4L72 215.24a6 6 0 0 0 3 4.53a105.65 105.65 0 0 0 25.77 10.66a6 6 0 0 0 5.29-1.11l19.1-15.32c1.89.06 3.79.06 5.68 0l19.21 15.38a6 6 0 0 0 3.75 1.31a6.2 6.2 0 0 0 1.54-.2a105.34 105.34 0 0 0 25.76-10.68a6 6 0 0 0 3-4.53l2.71-24.45q2.07-1.93 4-4l24.46-2.72a6 6 0 0 0 4.53-3a105.49 105.49 0 0 0 10.66-25.77a6 6 0 0 0-1.11-5.29Zm-3.1 41.63l-23.64 2.63a6 6 0 0 0-3.82 2a75.14 75.14 0 0 1-6.31 6.31a6 6 0 0 0-2 3.82l-2.63 23.63a94.28 94.28 0 0 1-17.36 7.14l-18.57-14.86a6 6 0 0 0-3.75-1.31h-.36a78.07 78.07 0 0 1-8.92 0a6 6 0 0 0-4.11 1.3L100.87 218a94.13 94.13 0 0 1-17.34-7.17l-2.63-23.62a6 6 0 0 0-2-3.82a75.14 75.14 0 0 1-6.31-6.31a6 6 0 0 0-3.82-2l-23.63-2.63A94.28 94.28 0 0 1 38 155.14l14.86-18.57a6 6 0 0 0 1.3-4.11a78.07 78.07 0 0 1 0-8.92a6 6 0 0 0-1.3-4.11L38 100.87a94.13 94.13 0 0 1 7.17-17.34l23.62-2.63a6 6 0 0 0 3.82-2a75.14 75.14 0 0 1 6.31-6.31a6 6 0 0 0 2-3.82l2.63-23.63A94.28 94.28 0 0 1 100.86 38l18.57 14.86a6 6 0 0 0 4.11 1.3a78.07 78.07 0 0 1 8.92 0a6 6 0 0 0 4.11-1.3L155.13 38a94.13 94.13 0 0 1 17.34 7.17l2.63 23.64a6 6 0 0 0 2 3.82a75.14 75.14 0 0 1 6.31 6.31a6 6 0 0 0 3.82 2l23.63 2.63a94.28 94.28 0 0 1 7.14 17.29l-14.86 18.57a6 6 0 0 0-1.3 4.11a78.07 78.07 0 0 1 0 8.92a6 6 0 0 0 1.3 4.11L218 155.13a94.13 94.13 0 0 1-7.15 17.34Z"/></svg>

                  Configure
                </button>
                <ul class="dropdown-menu m-auto" role="menu" aria-labelledby="dropdownMenuButton1">
                  <li role="none" v-if="sessionStore.inRole('SectionAuthorization.Admin')">
                    <button class="dropdown-item" role="menuitem" @click="$router.replace('/configure/expirations')">Expirations</button>
                  </li>
                  <li><hr class="dropdown-divider"></li>
                  <li role="none" v-if="sessionStore.inRole('SectionAuthorization.Admin')">
                    <button class="dropdown-item" role="menuitem" @click="$router.replace('/configure/infotext')">Infotext</button>
                  </li>
                  <li role="none" v-if="sessionStore.inRole('SectionAuthorization.Admin')">
                    <button class="dropdown-item" role="menuitem" @click="$router.replace('/configure/deadline-text')">Deadline Text</button>
                  </li>
                  <li><hr class="dropdown-divider"></li>
                  <li role="none" v-if="sessionStore.inRole('SectionAuthorization.Admin')">
                    <button class="dropdown-item" role="menuitem" @click="$router.replace('/configure/status-types')">Status Types</button>
                  </li>
                  <li role="none" v-if="sessionStore.inRole('SectionAuthorization.Admin')">
                    <button class="dropdown-item" role="menuitem" @click="$router.replace('/configure/email-content')">Email Content</button>
                  </li>
                </ul>
              </li>

          </ul>

        <div class="d-flex justify-content-end align-items-center">
          <button type="button" class="btn btn-transparent navbar-text d-flex justify-content-center align-items-center d-none d-lg-flex p-1" @click="open_impersonation_modal()" :aria-label="'User profile' + (sessionStore.isImpersonationSet ? ' - impersonating' : '') + ': ' + sessionStore.DisplayName">
            <span class="env-badge fw-bold pe-3" v-if="sessionStore.environment && sessionStore.environment !== 'prod'" aria-hidden="true">[{{sessionStore.environment}}]</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="text-purple-icon" width="24" height="24" viewBox="0 0 24 24" v-if="sessionStore.isImpersonationSet" aria-hidden="true" focusable="false"><path fill="currentColor" d="M8.11 19.45a6.948 6.948 0 0 1-4.4-5.1L2.05 6.54c-.24-1.08.45-2.14 1.53-2.37l9.77-2.07l.03-.01c1.07-.21 2.12.48 2.34 1.54l.35 1.67l4.35.93h.03c1.05.24 1.73 1.3 1.51 2.36l-1.66 7.82a6.993 6.993 0 0 1-8.3 5.38a6.888 6.888 0 0 1-3.89-2.34M20 8.18L10.23 6.1l-1.66 7.82v.03c-.57 2.68 1.16 5.32 3.85 5.89c2.69.57 5.35-1.15 5.92-3.84L20 8.18m-4 8.32a2.962 2.962 0 0 1-3.17 1.39a2.974 2.974 0 0 1-2.33-2.55L16 16.5M8.47 5.17L4 6.13l1.66 7.81l.01.03c.15.71.45 1.35.86 1.9c-.1-.77-.08-1.57.09-2.37l.43-2c-.45-.08-.84-.33-1.05-.69c.06-.61.56-1.15 1.25-1.31h.25l.78-3.81c.04-.19.1-.36.19-.52m6.56 7.06c.32-.53 1-.81 1.69-.66c.69.14 1.19.67 1.28 1.29c-.33.52-1 .8-1.7.64c-.69-.13-1.19-.66-1.27-1.27m-4.88-1.04c.32-.53.99-.81 1.68-.66c.67.14 1.2.68 1.28 1.29c-.33.52-1 .81-1.69.68c-.69-.17-1.19-.7-1.27-1.31m1.82-6.76l1.96.42l-.16-.8l-1.8.38Z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" class="text-white" width="24" height="24" viewBox="0 0 24 24" v-else aria-hidden="true" focusable="false"><g fill="none" fill-rule="evenodd"><path d="M24 0v24H0V0h24ZM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018Zm.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01l-.184-.092Z"/><path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2ZM8.5 9.5a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0Zm9.758 7.484A7.985 7.985 0 0 1 12 20a7.985 7.985 0 0 1-6.258-3.016C7.363 15.821 9.575 15 12 15s4.637.821 6.258 1.984Z"/></g></svg>
            <span class='pe-1 mx-2' :class="sessionStore.isImpersonationSet ? 'impersonating-name fw-bolder' : 'text-white'" aria-hidden="true">{{sessionStore.DisplayName}}</span>
          </button>
          <button type="button" class="btn btn-transparent navbar-text d-flex justify-content-center align-items-center d-none d-lg-flex p-1" v-on:click.prevent="copy_to_clipboard(sessionStore.accessToken)" v-if="this.sessionStore.environment !== 'prod' && sessionStore.inRole('SectionAuthorization.Developer')" aria-label="Copy access token to clipboard">
            <svg xmlns="http://www.w3.org/2000/svg" class="text-white" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7 15q1.25 0 2.125-.875T10 12q0-1.25-.875-2.125T7 9q-1.25 0-2.125.875T4 12q0 1.25.875 2.125T7 15Zm0 3q-2.5 0-4.25-1.75T1 12q0-2.5 1.75-4.25T7 6q2.025 0 3.538 1.15T12.65 10h8.375L23 11.975l-3.5 4L17 14l-2 2l-2-2h-.35q-.625 1.8-2.175 2.9T7 18Z"/></svg>
          </button>
        </div>
      </div>

    </div>


  </nav>

  <ImpersonatePerson 
    v-if="isImpersonateModalVisible"
    @close="isImpersonateModalVisible = false" />

</template>

<script>


import { useSessionStore } from './../stores/SessionStore'

import { defineComponent } from 'vue';
import ImpersonatePerson from './ImpersonatePerson.vue';

export default defineComponent({
    setup() {
        const sessionStore = useSessionStore();
        return { sessionStore };
    },
    data() {
      return {
        isImpersonateModalVisible: false,
        isAdminAddedManual: false,
        isCheckingAdmin: false,
        hasCheckedAdmin: false
      };
    },
    watch: {
      'sessionStore.uvid': {
        immediate: true,
        async handler(newVal) {
          if (newVal && !this.hasCheckedAdmin && !this.isCheckingAdmin) {
            await this.checkAdminStatus();
          }
        }
      }
    },
    name: 'application-header',
    props: [],
    methods: {
      async checkAdminStatus() {
        // return if user is not an admin :)
        if (!this.sessionStore.inRole('SectionAuthorization.Admin') && !this.sessionStore.inRole('SectionAuthorization.DepartmentAdmin') && !this.isAdminAddedManual) {
          return;
        }
        //haschecked is to avoid multiple calls of the api
        if (this.isCheckingAdmin || this.hasCheckedAdmin) return;
        
        this.isCheckingAdmin = true;
        try {
          const resp = await this.sessionStore.request_data('GET', '/departments/all/admins', 'Load all admins');
          const payload = (resp && typeof resp === 'object' && 'data' in resp) ? resp.data : resp;
          const adminsArr = Array.isArray(payload) ? payload : (payload ? Object.values(payload) : []);
          
          const me = String(this.sessionStore.uvid || '').trim().toUpperCase();
          this.isAdminAddedManual = adminsArr.some(a => String(a?.uvid || '').trim().toUpperCase() === me);
          this.hasCheckedAdmin = true;
        } catch (e) {
          console.error('Failed to check admin status:', e);
          this.isAdminAddedManual = false;
        } finally {
          this.isCheckingAdmin = false;
        }
      },
      // async list_admins() {
      //   await this.checkAdminStatus();
      //   return this.admins;
      // },


      open_impersonation_modal(){
        this.isImpersonateModalVisible = this.sessionStore.inRole('SectionAuthorization.Admin')
      },
      copy_to_clipboard(text) {
        if (this.sessionStore.environment !== 'prod') {
            navigator.clipboard.writeText(text);
        }
      }
    },
    components: { ImpersonatePerson }
});

</script>


<style scoped lang="scss">

.navbar-toggler-icon{
    font-size: 0.5em;
}

.navbar-toggler:focus {
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.75);
    outline: 2px solid #fff;
    outline-offset: 2px;
}

/* Bootstrap's default focus ring is a translucent blue box-shadow, which
   doesn't meet 3:1 contrast against the green (bg-uvu) navbar. Give nav
   links and nav buttons an opaque white outline instead. */
.nav-link:focus-visible,
.dropdown-toggle:focus-visible,
.btn-transparent:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.75);
}

.text-purple-icon {
  /* light enough to meet 3:1 non-text contrast against the bg-uvu (#00843e) navbar */
  color: #e0c9ff;
}

.impersonating-name {
  background-color: #ffffff;
  color: #6f42c1;
  padding: 0.1em 0.5em;
  border-radius: 0.25rem;
}

.env-badge {
  background-color: #ffffff;
  color: #664d03;
  padding: 0.1em 0.5em;
  border-radius: 0.25rem;
}

nav.navbar {
    position: relative;
    z-index: 1030;
}

</style>